import {
  CreatePaymentRequest,
  CreatePaymentRequestResp,
  CreatePaymentRequestRespSchema,
  Credit,
  CreditSchema,
  CreditTxWithMeta,
  CreditTxWithMetaSchema
} from "@garther/interfaces";
import { ApiRoute, getApiRoute } from "@garther/interfaces";
import { z } from "zod";

import { API_BASE_URL } from "../configs";
import { ApiClientConfig, BaseApiClient } from "./base-client";

export class CreditApiClient extends BaseApiClient {
  constructor(config: ApiClientConfig) {
    super({ ...config, baseEndpoint: getApiRoute(ApiRoute.CREDIT) });
  }

  // Get current user's credit balance
  async getMyCredits(): Promise<Credit> {
    return await this.get("me", CreditSchema, { requireAuth: true });
  }

  // Get specific user's credit balance
  async getUserCredits(userId: string): Promise<Credit> {
    return await this.get(`${userId}`, CreditSchema, { requireAuth: true });
  }

  // Get current user's transaction history
  async getMyTransactions(limit?: number): Promise<CreditTxWithMeta[]> {
    const params = limit ? `?limit=${limit}` : "";
    return await this.get(`me/transactions${params}`, z.array(CreditTxWithMetaSchema), {
      requireAuth: true
    });
  }

  // Get specific user's transaction history
  async getUserTransactions(userId: string, limit?: number): Promise<CreditTxWithMeta[]> {
    const params = limit ? `?limit=${limit}` : "";
    return await this.get(`${userId}/transactions${params}`, z.array(CreditTxWithMetaSchema), {
      requireAuth: true
    });
  }

  // Get credit price information
  async getCreditPriceInfo(): Promise<{ pricePerCredit: number; currency: string; description: string }> {
    return {
      pricePerCredit: 50000,
      currency: "VND",
      description: "Price per credit in Vietnamese Dong"
    };
  }

  // Create payment request
  async createPaymentRequest(data: CreatePaymentRequest): Promise<CreatePaymentRequestResp> {
    return await this.post("payment/create", CreatePaymentRequestRespSchema, data, {
      requireAuth: true
    });
  }
}

// Default instance
export const creditApiClient = new CreditApiClient({
  baseURL: API_BASE_URL,
  requireAuth: true
});
